import { SummaryItemCard } from "../../molecules/SummaryItemCard/SummaryItemCard";

export const SummarySection = ({ cards,isLoading }) => {
  // Cards array holds the tile component information
  //TODO: Array amount will replaced with real values

  return (
    <>
      {cards.map((item, index) => {
        return (
          <SummaryItemCard
            key={item.id}
            Image={item.image}
            heading={item.heading}
            amount={item.amount}
            status={item.status}
            marginRight={index !== cards.length - 1 && "12px"}
            isLoading={isLoading}
          />
        );
      })}
    </>
  );
};
